import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ViewBreakpointService } from '@common-module/app-services/view-breakpoint.service';
import { ConnectionStatus } from '@common-module/modelinterfaces/enums/connection-status';
import { SensorTypeName } from '@common-module/modelinterfaces/enums/sensor-type-name';
import { SensorLastValue } from '@common-module/modelinterfaces/sensor-last-value.model';
import { UnitAdditionalData } from '@common-module/modelinterfaces/unit-additional-data.model';
import { AuthUserService } from '@common-module/app-services/auth-user.service';
import { SecToStringDurationPipe } from '@common-module/pipes/sec-to-string-duration.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { SensorValuePipe } from '@common-module/pipes/sensor-value.pipe';
import { TimestampTimezoneConvertPipe } from '@common-module/pipes/timestamp-timezone-convert.pipe';
import {CommonModule} from "@angular/common";

@Component({
    selector: 'app-device-status-card',
    templateUrl: './device-status-card.component.html',
    styleUrls: ['../carousel-card-styles.component.scss'],
    imports: [CommonModule, SecToStringDurationPipe, TranslateModule, SensorValuePipe, TimestampTimezoneConvertPipe]
})

export class DeviceStatusCardComponent implements OnChanges {

  @Input() width: number;
  @Input() unitData: UnitAdditionalData;

  public connectionStatus = ConnectionStatus;
  public sensorBatteryLevel: SensorLastValue;
  public sensorGsmLevel: SensorLastValue;
  public timeZone: string;

  constructor(public viewBreakpointService: ViewBreakpointService,
              private authUserService: AuthUserService) {
    this.timeZone = this.authUserService.getInstantTimeZone();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['unitData']) {
      this.sensorGsmLevel = this.unitData.getSensorLastValueByType(SensorTypeName.GSM_STRENGTH);
      this.sensorBatteryLevel = this.unitData.getSensorLastValueByType(SensorTypeName.DEVICE_BATTERY);
    }
  }
}
